import React, { Component } from 'react';
import './HomeVideo.scss';

class HomeVideo extends Component {

    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <div className='hidden-xs'>
              <div className='container'>
                <div className="home-video">
                <img src={this.props.src} alt=""/>
                </div>
              </div>
            </div>
        )
    }
}

export default HomeVideo;



// WEBPACK FOOTER //
// ./src/views/pages/Home2/HomeVideo/index.js